"use client";

import { IconChevronDown } from "@tabler/icons-react";
import { ReactNode, useState, useEffect } from "react";

const AccordeonBasic = ({
  children,
  title,
  className,
  reverseCheveron = false,
  isOpen,
  onToggle
}: {
  children: ReactNode;
  title: ReactNode;
  reverseCheveron?: boolean;
  className?: string;
  isOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
}) => {
  const [showMore, setShowMore] = useState(!!isOpen);

  // Determine if we're in controlled or uncontrolled mode

  const handleToggle = () => {
    setShowMore(prev => !prev);
  };

  return (
    <div className={`${className}  flex flex-col overflow-hidden rounded-lg `}>
      <button
        type='button'
        onClick={handleToggle}
        className={`${reverseCheveron ? 'flex-row-reverse justify-end gap-2' : 'justify-between'}
          items-center font-bold text-left text-sm md:text-base transition-colors duration-300 w-full    flex `}
      >
        <span> {title}</span>
        <IconChevronDown
          className={`${showMore ? "rotate-180" : "rotate-0"}
            ${reverseCheveron ? "text-indigo-500" : ""}
            w-5 min-w-5 transition-transform duration-300`}
        />
      </button>
      <div
        className={`${showMore ? "grid-rows-[1fr]" : "grid-rows-[0fr]"} 
      peer-open:  grid 
       transition-[grid-template-rows]  w-full duration-500`}
      >
        <div
          className={`flex w-full text-sm md:text-base flex-col gap-2 overflow-hidden transition-all duration-300 ${showMore ? "mt-0" : "mt-0"}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default AccordeonBasic;
